import { TStockFormValues } from './StockForm.types';

export const STOCK_FORM_DEFAULT_VALUES: TStockFormValues = {
  name: '',
  variation: '',
  quantity: 0,
  type: 'phoneCase',
};
